<template>
    <v-touch @swipeleft="toggle"
             @swiperight="toggle"
             class="switch-button-control">
        <div class="switch-button" :class="{ enabled: isEnabled, new: isNewDesign }" @click="toggle">
            <div class="button-bullet"></div>
        </div>
        <div class="switch-button-label">
            <slot></slot>
        </div>
    </v-touch>
</template>

<script>
    export default {
        name: 'switch-button',
        model: {
            prop: "isEnabled",
            event: "toggle"
        },
        props: {
            isEnabled: Boolean,
            isNewDesign: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            toggle: function() {
                this.$emit("toggle", !this.isEnabled);
            }
        }
    }
</script>

<style lang="less">
    @import "../../less/variables.less";

    // For switch-button styling
    .switch-button-control {
        display: flex;
        flex-direction: row;
        align-items: center;

        .switch-button {
            @switch-button-height: 20px;
            @switch-button-color: @primary;
            @switch-button-border-thickness: 2px;
            @switch-transition: all 0.3s ease-in-out;
            @switch-is-rounded: true;

            height: @switch-button-height;
            width: @switch-button-height * 2;
            border: @switch-button-border-thickness solid white;
            border-radius: if(@switch-is-rounded, @switch-button-height, 0);
            background: white;

            transition: @switch-transition;

            @button-side-length: @switch-button-height - 2 * @switch-button-border-thickness;

            cursor: pointer;

            .button-bullet {
                height: @button-side-length;
                width: @button-side-length;
                border: @switch-button-border-thickness solid white;
                border-radius: if(@switch-is-rounded, @button-side-length, 0);
                background: @grey;

                transition: @switch-transition;
            }

            &.enabled {
                .button-bullet {
                    background: @switch-button-color;
                    transform: translateX(@button-side-length + 2 * @switch-button-border-thickness);
                }

                &.new {
                    .button-bullet {
                        background: #555555;
                        transform: translateX(@button-side-length + 2 * @switch-button-border-thickness);
                    }
                }
            }
        }

        .switch-button-label {
            margin-left: 10px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/switch-button/SwitchButton.vue